import './Tag.css'

/**
 * Render simple tags
 * 
 * @param {string} tag - Displayed text on the tag
 * @param {string} icon - Font icon name.
 * @param {string} type - 'success' | 'info' | 'warning' | 'error' | 'default' 
 * @param {string} aspect - 'filled' | 'transparent'
 * @param {string} size - 'default' | 'small'
 * @returns 
 */
export const Tag = ({ tag, icon, type, aspect, style, partiallIssued }) => {
  return (<span className={`tag-component ${aspect ?? 'filled'} ${type} ${partiallIssued ? 'partial-issued-tag' : ''}`} style={style}>
    {icon && <i className={icon}></i>}
    {tag}
    {partiallIssued && <div className='issue-container'><i className="icon-issue"></i></div> }
  </span>)
}